// extracted by mini-css-extract-plugin
var _1 = "FilesListUploadItem-moduleFilesListUploadItem__syquZ";
var _2 = "FilesListUploadItem-moduleplaceholder__ar1_6 FileUploadPlaceholder-moduleFileUploadPlaceholder__LRagJ";
export { _1 as "FilesListUploadItem", _2 as "placeholder" }
